import { useEffect, useState } from "react";
import { baseAPIUrl } from "../../../Utils/BaseAPI"
import CreateOrEdit from "./CreateOrEdit";
import { useNavigate } from "react-router-dom";
import axios, { AxiosError, AxiosResponse } from "axios";
import Swal from "sweetalert2";
import DriverType from "./Interfaces/DriverInterface";
// import './css/style.css';

interface SubmitResponse {
    Error?: string,
    Id: number,
    Message: string,
    Success: boolean,
    Warning: boolean
}


const CreateDriver = () => {
    const formAction = `${baseAPIUrl}CreateDriver`;
    const [formData, setFormData] = useState<DriverType>({
        id: 0,
        boxId: 0,
        name: '',
        implementation: '',
        category: '',
        configurationDriver: {
            port: '',
            address: ''
        },
        containerConfigurationId: 0,
        diverterNumber: 0,
        hasDiverterNumber: false
    });

    const navigate = useNavigate();

    const handleSubmit = (event: any) => {
        event.preventDefault();
        axios.post(formAction, formData)
        .then((result: AxiosResponse) => {
            if (result && result.data.Success) {
                const Toast = Swal.mixin({
                    toast: true,
                    position: 'center',
                    showConfirmButton: false,
                    timer: 2500,
                    timerProgressBar: true,
                    didOpen: (toast) => {
                        toast.addEventListener('mouseenter', Swal.stopTimer)
                        toast.addEventListener('mouseleave', Swal.resumeTimer)
                    },
                    didClose: () => {
                        navigate('/configurations/driver');
                    }
                })

                Toast.fire({
                    icon: 'success',
                    title: 'Driver creato correttamente'
                })
            } else {
                const Toast = Swal.mixin({
                    toast: true,
                    position: 'center',
                    showConfirmButton: false,
                    timer: 2500,
                    timerProgressBar: true,
                    didOpen: (toast) => {
                        toast.addEventListener('mouseenter', Swal.stopTimer)
                        toast.addEventListener('mouseleave', Swal.resumeTimer)
                    }
                })

                Toast.fire({
                    icon: 'error',
                    title: 'Errore nella creazione del driver'
                })
            }
        })
        .catch((error: AxiosError) => {
            const Toast = Swal.mixin({
                toast: true,
                position: 'center',
                showConfirmButton: false,
                timer: 2500,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener('mouseenter', Swal.stopTimer)
                    toast.addEventListener('mouseleave', Swal.resumeTimer)
                }
            })

            Toast.fire({
                icon: 'error',
                title: 'Errore nella creazione del driver'
            })
        })
    };

    return (
        <>
            <form className="form" onSubmit={handleSubmit} id="form-create-driver">
                <CreateOrEdit formData={formData} setFormData={setFormData}></CreateOrEdit>
            </form>
        </>
    )
}

export default CreateDriver;